import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdOauthMcpSettingsPartnerAppsEnabledCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/oauth_mcp_settings/partner_policies",
];
